module.exports = __webpack_public_path__ + "img/pitchtype-fully-serviced.2.bb37fe6.jpg";